var Utility = (function () {

    var self = {};

    self.getURLParams = function () {
        var url = window.location.href;
        var retObject = {};
        var parameters;

        if (url.indexOf('?') === -1) {
            return retObject;
        }

        url = url.split('?')[1];
        parameters = url.split('&');

        for (var i = 0; i < parameters.length; i++) {
            retObject[parameters[i].split('=')[0]] = parameters[i].split('=')[1];
        }

        return retObject;
    };

    self.arrayToQueryString = function (array_in) {
        var out = [];

        for (var key in array_in) {
            out.push(key + '=' + encodeURIComponent(array_in[key]));
        }

        return out.join('&');
    };

    return self;

}());

module.exports = Utility;
